import React from 'react';
import { TextLog } from 'modules/emergencies/components/ui/texts/LogText';
import { LogTitleContainer } from '../../ui/containers/logTitleContainer';
import LogIcon from 'modules/emergencies/components/log/LogIcon';

const TicketLogTitle = ({ titleData = {}, title, icon }) => {
  const { hasSubtitle, subtitle } = titleData;

  return (
    <LogTitleContainer>
      <LogIcon icon={icon} />
      <TextLog color="#263340">{title}</TextLog>
      {hasSubtitle && <TextLog color="#54708C">/ {subtitle || '-'}</TextLog>}
    </LogTitleContainer>
  );
};

export default TicketLogTitle;
